export default __webpack_public_path__ + "static/media/bottle.bd6b8600.jpg";